// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2j5Lz","label":"Category_label__30mwT","content":"Category_content__3plA2","header":"Category_header__2lIVR","location":"Category_location__2gElI"};